import { CONSTANTS } from "src/constants";
import {
  ApproveTimeSheet,
  TimesheetUpdatePayload,
} from "src/models/timesheet.models";
import { replacePlaceholders } from "src/utils/common.utils";

import API_URL from "./apiConfig/api.config";
import handleResponse from "./apiConfig/api.response.service";
import apiCall from "./apiConfig/apiCall.config";

export const approveRejectTimeSheet = async (payload: ApproveTimeSheet) => {
  const { uuid, ...props } = payload;
  const url = API_URL.TIMESHEET.APPROVE_REJECT_TIMESHEET.replace(
    CONSTANTS.TIMESHEET.TIMESHEET_UUID,
    uuid as string
  ).replace(/[{}]/g, "");
  return await apiCall.patch(url, props);
};

export const getTimesheetDetails = async (uuid: string) => {
  const res = await apiCall.get(API_URL.TIMESHEET.GET_TIMESHEET_DETAILS + uuid);
  const responseData = await handleResponse(res);
  if (responseData.ok) {
    return responseData?.data;
  } else {
    return responseData;
  }
};
export const getTimesheetList = async (
  payload: { [key: string]: string | number | number[] } | undefined
) => {
  const res = await apiCall.get(API_URL.TIMESHEET.GET_TIMESHEET_LIST, payload);
  const responseData = await handleResponse(res);
  if (responseData.ok) {
    return responseData?.data;
  } else {
    return responseData;
  }
};

export const getLateSubmitTimeSheet = async (
  payload: { [key: string]: string | number | number[] } | undefined
) => {
  const res = await apiCall.get(
    API_URL.TIMESHEET.GET_LATE_SUBMIT_TIME_SHEET,
    payload
  );
  return res;
};
export const getProfessionalTimesheetList = async (
  uuid: string,
  payload: { end_date: string; start_date: string }
) => {
  const url = API_URL.TIMESHEET.GET_PROFESSIONAL_TIMESHEET_LIST.replace(
    "professionalUuid",
    uuid
  ).replace(/[{}]/g, "");
  const res = await apiCall.get(url, payload);
  return res;
};

/**
 * Updates a professional timesheet with the given UUID and payload.
 *
 * @param uuid - The unique identifier of the timesheet to update.
 * @param payload - The data to be updated on the timesheet.
 * @returns A promise resolving to the response of the PATCH API call.
 *
 */
export const updateTimesheet = async (
  uuid: string,
  payload: TimesheetUpdatePayload
) => {
  const url = replacePlaceholders(
    API_URL.TIMESHEET.UPDATE_PROFESSIONAL_TIMESHEET,
    {
      uuid: uuid,
    }
  );
  return await apiCall.patch(url, payload);
};
